import { render, staticRenderFns } from "./PopupSelectRevision.vue?vue&type=template&id=2ac97abb&scoped=true&"
import script from "./PopupSelectRevision.vue?vue&type=script&lang=js&"
export * from "./PopupSelectRevision.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac97abb",
  null
  
)

export default component.exports